import React, { Component } from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { StyledEngineProvider } from '@mui/material/styles';
// Import Routes
import { publicRoutes, authProtectedRoutes, adminRoute } from "./routes/";
import AppRoute from "./routes/route";

import InjectAxiosInterceptors from "./helpers/InjectAxiosInterceptors";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./theme.scss";
import "./App.css";

// Import MUI ThemeProvider and createTheme
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();

    return (
      <React.Fragment>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Router>
              <InjectAxiosInterceptors />
              <Switch>
                {authProtectedRoutes.map((route, idx) => {
                  return (
                    <AppRoute
                      path={route.path}
                      layout={VerticalLayout}
                      component={route.component}
                      key={idx}
                      isAuthProtected={true}
                      allowedRoles={["Users", "Admin", "PowerUser"]}
                    />
                  );
                })}
                {adminRoute.map((route, idx) => {
                  return (
                    <AppRoute
                      path={route.path}
                      layout={VerticalLayout}
                      component={route.component}
                      key={idx}
                      isAuthProtected={true}
                      allowedRoles={["Admin"]}
                    />
                  );
                })}
                {publicRoutes.map((route, idx) => {
                  return (
                    <AppRoute
                      path={route.path}
                      layout={NonAuthLayout}
                      component={route.component}
                      key={idx}
                      isAuthProtected={false}
                      allowedRoles={["Admin", "Users", "", "PowerUser"]}
                    />
                  );
                })}
              </Switch>
            </Router>
          </ThemeProvider>
        </StyledEngineProvider>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.layout,
  };
};

export default connect(mapStateToProps, null)(App);
